import styled from "styled-components";
import { FormControlLabel } from "@material-ui/core";

export const FormControlStyled = styled(FormControlLabel)`
  & .MuiTypography-body1 {
    font-family: 'AvertaPE';
    color: #1B2852;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
  }  
  &.MuiFormControlLabel-root {
   min-height: 60px;
   justify-content: space-between;
   margin: 0;
   padding: 0;
   padding-top: 20px;
   padding-bottom: 20px;
   padding-left: 14px;
   border-bottom: 1px solid #D9DFF8;
   
    & .Mui-checked {
      color: #006BEE!important;
    }
    & .MuiRadio-root {
      color: #69769B;
    }
  }
`